import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container } from '@easymoving/ui';
import { BottomNav } from '../../components/app/BottomNav';
import { DesktopNav } from '../../components/app/DesktopNav';
import { GuestBanner } from '../../components/app/GuestBanner';
import { WorkspaceBanner } from '../../components/app/WorkspaceBanner';
import { useOptionalBackend } from '../../lib/backend/context';

/**
 * Layout for the app: page content + mobile bottom nav. Works for both guests
 * (LocalBackend) and signed-in users (CloudBackend) — no auth gate. Waits for
 * the backend to resolve so child pages always have one.
 */
export function AppLayout() {
  const { t } = useTranslation();
  const backend = useOptionalBackend();

  if (!backend) {
    return (
      <Container>
        <p className="text-graphite py-12">{t('common.loading')}</p>
      </Container>
    );
  }

  return (
    <div className="flex flex-col min-h-[calc(100vh-4rem)]">
      <GuestBanner />
      <WorkspaceBanner />
      <DesktopNav />
      {/* extra bottom padding on mobile so content clears the fixed BottomNav */}
      <div className="flex-1 pb-[calc(4.5rem+env(safe-area-inset-bottom))] md:pb-4">
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}
